export default "__VITE_ASSET__1695bdec__"